import { apiInterfaceForJson } from '../common/apiManager';

export const fetchQcRanges = () => {
    return apiInterfaceForJson('/qcRange/v1/', 'GET');
};

export const searchQcRanges = (filter) => {
    return apiInterfaceForJson('/qcRange/v1/search', 'POST', filter);
};

export const getQcRangeDataById = (qcRangeId) => {
    return apiInterfaceForJson('/qcRange/v1/' + qcRangeId, 'GET');
};

export const createQcRange = (qcRangeDetails) => {
    return apiInterfaceForJson('/qcRange/v1/', 'POST', qcRangeDetails);
};

export const updateQcRange = (qcRangeDetails) => {
    return apiInterfaceForJson('/qcRange/v1/', 'PUT', qcRangeDetails);
};

export const deleteQcRange = (qcRangeDetails) => {
    return apiInterfaceForJson('/qcRange/v1/delete', 'POST', qcRangeDetails);
};
